import TransactionsHeader from './TransactionsHeader';
import TransactionsTable from './TransactionsTable';

function Transactions() {
	return (
		<div className="flex flex-col min-w-0 flex-auto">
			<div className="flex-1">
				<div className="max-w-6xl mx-auto space-y-6">
					<div className="w-full h-full flex flex-col px-4">
						<TransactionsHeader />
						<TransactionsTable />
					</div>
				</div>
			</div>
		</div>
	);
}

export default Transactions;

